import FooterInfo from './src/footer-info.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpFooterInfo = withInstall(FooterInfo)
export default EpFooterInfo
export * from './src/footer-info'
